import type { EnvironmentConfig, SwingParams, Vec3 } from '../types';
import { createFlightSetup } from '../physics/FlightSetup';
import { simulateFullFlight } from '../physics/BallFlightModel';

/** Camera-only forecast. The roll margin is framing space, not a predicted result. */
export function predictFlightFrame(params: SwingParams, environment: EnvironmentConfig): Vec3[] {
  const { state, context } = createFlightSetup(params, environment);
  const preview = simulateFullFlight(state, 1 / 120, context.wind, 20, context.airDensity, context.correction);
  const points = preview.filter((_, i) => i % 12 === 0 || i === preview.length - 1).map(frame => frame.position);
  const landing = preview[preview.length - 1].position;
  points.push({ ...landing, y: 0, z: landing.z + Math.max(10, Math.abs(landing.z) * .15) });
  return points;
}
